import { useState, useEffect, useContext } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { AppContext } from '../App';
import logo_wide from '../assets/logo_wide.png';
import { MdSend } from 'react-icons/md';

export default function TopBar (props) {

  const appContext = useContext(AppContext);
  const [ submitter, setSubmitter ] = useState(() => { return props.submitter })
  const [ text, setText ] = useState('');
  const [ lockKeyboard, setLockKeyboard ] = useState(false);

  const sendMessage = async () => {
    if(text && text.trim().length > 0) {
      //lock typing
      setLockKeyboard(true);
      appContext.setShowOverlayLoader(true);
      await submitter(text).then(result => {
        if(result) {
          setText('');
        }
      })
      appContext.setShowOverlayLoader(false);
      //unlock typing
      setLockKeyboard(false);
    } else {
      appContext.tellError('Empty message');
    }

  }

  const writeMessage = (text) => {
    if(!lockKeyboard) {
      setText(text);
    }
  }

  useEffect(() => {
    if(props.submitter) {
      setSubmitter(() => { return props.submitter });
    }
  }, [ props.submitter ])

  return (
    <div className="TypingBox">
      <div className="d-flex" style={{ height: "100%" }}>
        <div className='mNoMargin flex-grow-1'>
          <textarea
              placeholder="Text here...."
              onChange={(e) => { writeMessage(e.target.value) }}
              className="mNoMargin"
              value={text}
            />
        </div>
        <MdSend  onClick={sendMessage} size={30} color="var(--goldish)" className="align-self-center" style={{ marginRight: "10px", marginLeft: "10px", cursor: "pointer", flexShrink: "0", flexBasis: "40px" }}/>
        <button onClick={appContext.navBack} className='btn btn-rounded bg-redish align-self-center' style={{ fontSize: "10px", width: "100px", padding: "4px", flexShrink: "0", flexBasis: "100px" }}>
          Back To Game
        </button>
      </div>
    </div>
  )
}
